<template>
  <div class="Buscar">
    <Menu :sesion="sesion" :url="url" v-if="sesion" />
    <Submenu :menuActivo="3" :url="url" />

    <div class="container-fluid">

      <!--Mensaje en caso de no encontrar nada -->
      <div class="d-flex justify-content-center mt-5" v-if="mensajenull != ''">
        <h2>{{mensajenull}}</h2>
      </div>

      <!--Listado de Proyectos-->
      <div class="pt-3" v-else>
          <div class="card">
            <div class="card-body">
              <h4>Resultados ({{cantidad}}): </h4>
              
              <table class="table table-hover">
                <thead>
                  <tr>
                      <th style="width: 25% !important">Nombre Proyecto</th>
                      <th>Solicitante</th>
                      <th>Pais</th>
                      <th>Idioma</th>
                      <th>Producto</th>
                      <th>Fecha Entrega</th>
                      <th>Conocimiento Principal </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="f in proyectos" :key="f.id_proyecto">
                    <td>
                      <router-link :to="{ name: 'Detalle', params: { id: f.id_proyecto}}">
                        {{ f.titulo_proyecto }}
                      </router-link> 
                    </td>
                    <td>
                        <div class="row"> 
                            <div class="col-sm-3">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-9">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_empresa}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                      <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td> {{ f.idioma }} </td>
                    <td> {{ f.producto }} </td>
                    <td> {{ f.fecha_cierre }} </td>
                    <td> <span class="badge badge-success">{{ findEsp(f.esp1) }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>

      <!--Spinner-->
      <div class="d-flex justify-content-center mt-5" v-if="status == true">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import Submenu from "@/components/Submenu";
import Menu from "@/components/Menu";
import StarRating from 'vue-star-rating'

export default {
name: "Buscar",
mixins: [ globalFunctions ],
components: {Submenu,Menu,StarRating},
data() {
  return {
    proyectos: [],
    esp: [],
    sesion: false,
    status: false,
    rol: localStorage.rol,
    mensajenull : '',
    t_user: '',
    cantidad: 0
  };
},
methods: {
  getData() {
    //tipo de usuario
    this.axios.post(this.url + "consultasBasicas.php", { flag: 6, id: localStorage.userID }).then((responce) => {
        this.t_user = responce.data[0].t_user;
    });

    //Get Especialidad
    this.axios.post(this.url + "consultasBasicas.php", { flag: 1 }).then((responce) => {
        //console.log(responce.data);
        this.esp = responce.data;
    });
    
    let data = {
      flag: 6,
      id: localStorage.userID,
    };
    
    this.status = true;

    this.axios.post(this.url + "getProyectos.php", data).then((responce) => {
        //console.log(responce);
        if (responce.status == 200) {
          var proyectos = [];
          proyectos = responce.data;

          if(proyectos == null){
            this.mensajenull = 'Por el momento no hay proyectos que coincidan con tu perfil';
            this.cantidad = 0;
          }
          else {
            this.proyectos = proyectos;
            this.cantidad = responce.data.length;
          }
        }

        this.status = false;
      });
  },
  
  findEsp(value) {
    for (var i = 0; i < this.esp.length; i++) {
      if (this.esp[i].id_modulo === value) {
        return this.esp[i].module_cod + " - " + this.esp[i].module_name;
      }
    }
  },

},
computed:{
  ...mapState(['url'])
},
mounted() {
  this.getData();
  //check
  let resp = this.checkUser();
  this.sesion = resp;
},
};
</script>


<style scoped>

  .spinner-border{
    color: #ff200b;
  }

  .bandera-star .star{
    margin-right: -15px;
  }
  .bandera-star .bandera{
   text-align: right;
   margin-right: -80px;
   margin-top: 3px;
  }
  .mensaje-post{
    margin-top: 150px;
    margin-bottom: 150px;

  }
</style>


// WEBPACK FOOTER //
// src/views/Buscar/Buscar.vue